import SectionChild from '~/components/SectionChild';
import Heading2 from './heading2';
import { cn } from '@repo/ui/lib/utils';

type Benefit = {
  title: string;
  description: string;
};

const benefits: Benefit[] = [
  {
    title: 'Hệ thống số hóa chọn lọc khách hàng phù hợp',
    description:
      'Không còn cảnh gọi điện “rải” khắp nơi. Với công nghệ số hóa của KLand, hệ thống sẽ tự động phân tích nhu cầu và chọn lọc đối tượng khách hàng tiềm năng nhất, giúp bạn tập trung vào giao dịch chất lượng – chính xác – nhanh chóng.',
  },
  {
    title: 'Quỹ dự án độc quyền',
    description:
      'Kho dự án đa dạng và kiểm định chặt chẽ từ KLand mang đến cho bạn lợi thế cạnh tranh khác biệt. Bạn dễ dàng tiếp cận nguồn sản phẩm chất lượng, đầy đủ pháp lý và chính sách, sẵn sàng chia sẻ cho khách hàng.',
  },
  {
    title: 'Công nghệ quản lý và hỗ trợ môi giới hiện đại',
    description:
      'Nền tảng quản lý tập trung giúp theo dõi tiến độ, chăm sóc khách hàng và vận hành giao dịch thuận tiện ở mọi lúc, mọi nơi. Bạn được hỗ trợ toàn diện để tối ưu hóa hiệu suất và tăng trưởng thu nhập.',
  },
];

export default function RecruitmentBenefits() {
  return (
    <SectionChild className="py-[100px]">
      <div className="max-w-4xl pb-10 mx-auto text-center">
        <Heading2>
          Gia nhập KLand – Khởi đầu hành trình môi giới công nghệ, thu nhập
          không giới hạn
        </Heading2>
        <p className="mt-4 text-base leading-relaxed text-gray-600">
          Chúng tôi luôn tìm kiếm những cộng sự nhiệt huyết để mở rộng mạng lưới
          môi giới công nghệ. Cùng nhau, chúng ta tạo nên trải nghiệm bất động
          sản minh bạch, chuyên nghiệp và hiệu quả hơn cho khách hàng.
        </p>
      </div>

      <div className="overflow-hidden bg-white">
        <div className="flex flex-wrap gap-5 mt-[60px] divide-[#CCE9E6] md:divide-y-0 md:divide-x justify-center lg:grid lg:grid-cols-3 -mx-6">
          {benefits.map((benefit, idx) => (
            <div key={benefit.title} className={cn("px-6 md:px-8 max-w-[350px] lg:max-w-full",idx===0 &&"md:border-l lg:border-l-0")}>
              <div className="border-0 border-b border-b-primary">
                <h3 className="text-xl font-semibold text-primary pb-4 lg:max-w-[80%] font-helve min-h-[72px]">
                  {benefit.title}
                </h3>
              </div>

              <p className="pb-5 mt-4 text-sm leading-relaxed text-gray-600">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </SectionChild>
  );
}

